import React, { useEffect } from "react";
import { useAuthenticator } from "@aws-amplify/ui-react";
import ErrorBoundary from "./ErrorBoundary";
import { setGlobalErrorUser, setupGlobalErrorHandlers } from "./setupGlobalErrorHandlers";

export function ErrorBoundaryWithAuth({ children }: React.PropsWithChildren<{}>) {
  const { user } = useAuthenticator((context) => [context.user]);

   useEffect(() => {
    if (user) {
      const userId = user.userId;
      setGlobalErrorUser(userId);
    } else {
      setGlobalErrorUser(undefined);
    }
  }, [user]);

  return <ErrorBoundary user={user}>{children}</ErrorBoundary>;
}
